/**
 *  弹出框
 *
 */
'use strict';
angular.module('weixinAddCompModule', []).controller('weixinAddCompController', ['$scope', 'draftParams', '$modalInstance', 'trsHttpService', '$q', 'modalDialog', 'trsspliceString', 'wechatBtnService', '$state',
    function($scope, draftParams, $modalInstance, trsHttpService, $q, modalDialog, trsspliceString, wechatBtnService, $state) {
        initStatus();
        initData();

        /**
         * [initStatus description]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                massArray: draftParams.array,
                selectedArray: [],
                items: [],
            };
            $scope.status = {
                isSearch: false,
                copyCurrPage: 1,
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
            };
            $scope.query = {
                SearchWord: '',
                ChannelId: $state.params.wxchannelid,
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
                isOnlyMine: false,
                methodname: 'querySignedDoc',
                serviceid: 'mlf_wechat',
                isZuBan: true,
                ExceptMetaDataIds: trsspliceString.spliceString($scope.data.massArray, 'METADATAID', ','),
            };
        }

        /**
         * [initData description]
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
        }


        /**
         * [requestData description]
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.query, 'get').then(function(data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                $scope.data.selectedArray = [];
                $scope.page = data.PAGER;
            });
        }

        // 单选
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        $scope.pageChanged = function() {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [fullTextSearch description] 搜索
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function($event) {
            if ($event !== undefined && $event.keyCode !== 13) {
                return;
            }
            requestData();
        };

        /**
         * [confirm description] 提交
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $modalInstance.close($scope.data.selectedArray);
        };


        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    },
]);
